import { useMemo } from 'react';
import { useIntercom } from 'react-use-intercom';

import { RestworldManagerCard, SkeletonEmployerCardLoading } from '@restworld/ui-ds';
import { Organization } from '@restworld/utility-types';

function DashboardRestworldManagerCard({
  organisationDetails,
  isLoading,
}: {
  organisationDetails?: Organization;
  isLoading?: boolean;
}) {
  const { showMessages } = useIntercom();

  const { name, surname, icon_url, email, phone_number } = useMemo(() => {
    if (organisationDetails && organisationDetails?.assigned_to_rw_member) {
      const {
        assigned_to_rw_member: {
          name,
          surname,
          icon_url,
          user: { email, phone_number },
        },
      } = organisationDetails;
      return { name, surname, icon_url, email, phone_number };
    } else {
      return {};
    }
  }, [organisationDetails]);

  if (isLoading) {
    return <SkeletonEmployerCardLoading />;
  }

  if (!organisationDetails?.assigned_to_rw_member) return null;

  return (
    <RestworldManagerCard
      name={name}
      surname={surname}
      iconUrl={icon_url}
      email={email}
      phoneNumber={phone_number}
      openIntercom={showMessages}
    />
  );
}

export default DashboardRestworldManagerCard;
